<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-btn to="wholesale-inquiry-page-create" color="blue" class="mb-2">Utwórz stronę zapytania</v-btn>
                <data-table
                    ref="table"
                    :headers="headers"
                    :items="pages"
                    :options.sync="options"
                    :server-items-length="totalPages"
                    :loading="loading"
                    class="row-pointer"
                    @click:row="onRowClicked"
                >
                    <template v-slot:item.url="{ item }">
                        <span @click.stop><a :href="landingBaseUrl + '/zapytanie/' + item.slug" target="_blank">{{ landingBaseUrl }}/zapytanie/{{ item.slug }}</a></span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-btn class="red mt-2" @click.stop="deletePage(item)" depressed>
                            <v-icon dark>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import api from '../services/api';
import DataTable from "@/components/data-table/DataTable";
import permissions from '@/mixins/permissions';

export default {
    mixins: [permissions],
    components: {DataTable},
    data() {
        return {
            landingBaseUrl: process.env.VUE_APP_LANDING_URL,
            pages: [],
            totalPages: 0,
            loading: true,
            options: {},
            headers: [
                {text: 'Tytuł', value: 'title', sortable: false},
                {text: 'URL', value: 'url', sortable: false},
                {text: 'Akcje', value: 'actions', sortable: false},
            ],
        }
    },
    methods: {
        async getPages() {
            this.loading = true;
            const response = await api.get('/api/wholesale-inquiry-pages');
            this.loading = false;
            this.pages = response.data.items;
            this.totalPages = response.data.total;
        },
        onRowClicked(page) {
            this.$router
                .push({name: 'wholesale-inquiry-page-details', params: {id: page.id}})
                .catch((error) => {
                    if (String(error).includes('Avoided redundant navigation to current location')) {
                        return;
                    }
                    throw error;
                });
        },
        async deletePage(item) {
            await api.delete(`/api/wholesale-inquiry-pages/${item.id}`);
            this.getPages();
        },
    },
    created() {
        this.getPages();
    }
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
    cursor: pointer;
}
</style>
